import { FunctionComponent } from 'react';

import { OptionImage } from 'components/profile/quiz/OptionImage';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';

interface ImageDisplayProps {
  option: consumer.IPatronQuizQuestionOption;
}

const QuizImageDisplay: FunctionComponent<ImageDisplayProps> = ({ option }) => {
  return (
    <div className="QuizModal-imageSelectOption">
      <div className="QuizModal-imageSelectOptionImageWrapper">
        <OptionImage option={option} className="QuizModal-imageSelectOptionImage" />
      </div>
      <Typography component="span" variant="body02Strong">
        {option.displayText}
      </Typography>
    </div>
  );
};

export default QuizImageDisplay;
